/* ============================================================
   LS HEADER — Mega menu interactions
   ============================================================ */

(function () {
  let megaTimer = null;
  let currentMega = null;
  const overlay = document.querySelector('[data-mega-overlay]');
  const triggers = document.querySelectorAll('[data-mega-trigger]');
  const panels = document.querySelectorAll('[data-mega-panel]');
  const mobileToggle = document.querySelectorAll('[data-mobile-toggle]');
  const mobileDrawer = document.querySelector('[data-mobile-drawer]');

  function openMega(id) {
    clearTimeout(megaTimer);
    closeAllMegas();
    const panel = document.querySelector(`[data-mega-panel="${id}"]`);
    const trigger = document.querySelector(`[data-mega-trigger="${id}"]`);
    if (panel) {
      panel.classList.add('open');
      overlay.classList.add('open');
      if (trigger) trigger.classList.add('active');
      currentMega = id;
    }
  }

  function closeMegaDelay() {
    megaTimer = setTimeout(closeAllMegas, 200);
  }

  function keepOpen() {
    clearTimeout(megaTimer);
  }

  function closeAllMegas() {
    panels.forEach(function (p) { p.classList.remove('open'); });
    triggers.forEach(function (t) { t.classList.remove('active'); });
    if (overlay) overlay.classList.remove('open');
    currentMega = null;
  }

  // Trigger hover/click
  triggers.forEach(function (trigger) {
    var id = trigger.getAttribute('data-mega-trigger');

    trigger.addEventListener('mouseenter', function () {
      openMega(id);
    });

    trigger.addEventListener('mouseleave', function () {
      closeMegaDelay();
    });

    trigger.addEventListener('click', function () {
      if (currentMega === id) {
        closeAllMegas();
      } else {
        openMega(id);
      }
    });
  });

  // Panel hover
  panels.forEach(function (panel) {
    panel.addEventListener('mouseenter', keepOpen);
    panel.addEventListener('mouseleave', closeMegaDelay);
  });

  // Overlay click
  if (overlay) {
    overlay.addEventListener('click', closeAllMegas);
  }

  // Close on Escape
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      closeAllMegas();
      if (mobileDrawer) mobileDrawer.classList.remove('open');
      if (overlay) overlay.classList.remove('open');
    }
  });

  // Mobile drawer
  mobileToggle.forEach(function (btn) {
    btn.addEventListener('click', function () {
      if (mobileDrawer) {
        mobileDrawer.classList.toggle('open');
        overlay.classList.toggle('open');
      }
    });
  });

  // Sticky header — add 'is-scrolled' class after 24px of scroll (for shrink + shadow)
  var nav = document.querySelector('.ls-nav');
  if (nav) {
    function updateScrolledState() {
      if (window.scrollY > 24) nav.classList.add('is-scrolled');
      else nav.classList.remove('is-scrolled');
    }
    window.addEventListener('scroll', updateScrolledState, { passive: true });
    // Close any open mega menu as soon as the page scrolls (panel is not sticky)
    var lastY = window.scrollY;
    window.addEventListener('scroll', function () {
      if (Math.abs(window.scrollY - lastY) > 8 && document.querySelector('[data-mega-panel].open')) closeAllMegas();
      lastY = window.scrollY;
    }, { passive: true });
    updateScrolledState();
  }

  // Sticky wrapper — apply is-sticky class on the section wrapper if data-sticky="true"
  var wrapper = document.querySelector('.ls-header-section');
  if (wrapper && wrapper.getAttribute('data-sticky') === 'true') {
    wrapper.classList.add('is-sticky');
  }

  // User dropdown — toggle on click, close on outside click + ESC
  var userTrigger = document.querySelector('[data-user-trigger]');
  var userWrap = document.querySelector('[data-user-menu]');
  if (userTrigger && userWrap) {
    function setUserOpen(open) {
      userTrigger.setAttribute('aria-expanded', open ? 'true' : 'false');
    }
    userTrigger.addEventListener('click', function (e) {
      e.stopPropagation();
      var isOpen = userTrigger.getAttribute('aria-expanded') === 'true';
      setUserOpen(!isOpen);
    });
    document.addEventListener('click', function (e) {
      if (!userWrap.contains(e.target)) setUserOpen(false);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') setUserOpen(false);
    });
  }
})();
